/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://2iutn34kwfbe7dgxswwztn5du4.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "verification",
            "endpoint": "https://dm8lnosure.execute-api.eu-central-1.amazonaws.com/prodny",
            "region": "eu-central-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-central-1:d7bef0ff-282b-458f-9cda-ab6b643a6e8f",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_gzKxcGezm",
    "aws_user_pools_web_client_id": "381hi5h5moass7f7le8lg6qtga",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "BIRTHDATE",
        "GIVEN_NAME",
        "FAMILY_NAME",
        "PICTURE"
    ],
    "aws_cognito_mfa_configuration": "ON",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "eu-central-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "SignicatSessions-prodny",
            "region": "eu-central-1"
        },
        {
            "tableName": "envVarHack-prodny",
            "region": "eu-central-1"
        }
    ],
    "aws_user_files_s3_bucket": "medforeldrefffc542004d246a2858952cfc10cf99b160238-prodny",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
